import { GameMultimediaUrls, GemType } from "./Game";

export interface GemProps {
  id: string;
  name: string;
  description?: string;
  image?: string;
}

export interface UserGemSchema {
  multimedia_urls: Record<string, any>;
  gem_image: string;
  game_path: string;
  id: number;
  game_id: number;
  gem_type: string;
}

export interface UserGem {
  gameThumbnails: GameMultimediaUrls;
  gemIcon: string;         
  gameLink: string;
  offChainGameId: number;
  onChainGameId: number;
  gemType: GemType;
}

export const getUserGemFromSchema = (schema: UserGemSchema): UserGem => ({
  gameThumbnails: schema.multimedia_urls as GameMultimediaUrls,
  gemIcon: schema.gem_image,         
  gameLink: schema.game_path,
  offChainGameId: Number(schema.id),
  onChainGameId: Number(schema.game_id),
  gemType: schema.gem_type as GemType,
});

export const getSchemaFromUserGem = (data: UserGem): UserGemSchema => ({
  multimedia_urls: data.gameThumbnails,
  gem_image: data.gemIcon, 
  game_path: data.gameLink,
  id: data.offChainGameId,
  game_id: data.onChainGameId,
  gem_type: data.gemType,
})